import CryptoJS from 'crypto-js';

export function encryptedValue(plaintext, key) {
  try {
    const keyHash = CryptoJS.SHA256(key);
    const iv = CryptoJS.lib.WordArray.random(8);

    const encrypted = CryptoJS.AES.encrypt(plaintext, keyHash, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return `${iv.toString(CryptoJS.enc.Base64)}|${encrypted.ciphertext.toString(CryptoJS.enc.Base64)}`;
  } catch {
    // silent error
  }
}

export function decryptedValue(encryptedData, key) {
  try {
    const [ivBase64, ciphertextBase64] = encryptedData.split('|');

    const keyHash = CryptoJS.SHA256(key);

    const iv = CryptoJS.enc.Base64.parse(ivBase64);
    const ciphertext = CryptoJS.enc.Base64.parse(ciphertextBase64);

    const cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext });

    const decrypted = CryptoJS.AES.decrypt(cipherParams, keyHash, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch {
    // silent error
  }
}
